import React, { useState } from "react";
import { IListViewField } from "src/components/Shared/ILIstViewField";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";
import { AppEntities } from "src/config/entities";

const CommodityWaybillsList = () => {
  const [showPopup, setShowPopup] = useState(true);

  const fields: IListViewField[] = [
    {
        fieldName: "id",
        title: "Id",
        fieldType: "string",
    },
    {
        fieldName: "companyName",
        title: "Company",
        fieldType: "string",
    },
    {
        fieldName: "vendorName",
        title: "Vendor",
        fieldType: "string",
    },
    {
        fieldName: "totalAmount",
        title: "Total Amount",
        fieldType: "number",
        format: {
            type: "fixedPoint",
            precision: 2,
        },
    },
];
  return (
    <>
      {/* <NewDocumentListView toolbarOptions={{ hidePostButton: true, hideCloneButton: true, hideTransactionButton: true }} fields={fields} entity={AppEntities.CommodityWaybills} /> */}
      <ListView fields={fields} entity={AppEntities.CommodityWaybills} createMoreActions={[]}>
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
};

export default CommodityWaybillsList;
